// @ts-nocheck
/**
 * Cloud Telephony app loader — a bespoke telephony-themed loader:
 *
 *   • A silver-blue neu-embossed disc (the "phone puck") with a
 *     rotating handset glyph and a signal dot orbiting its edge.
 *   • A pulsing 5-bar waveform beneath the puck, staggered to look
 *     like live call activity.
 *   • "Loading" text with a fading three-dot ellipsis that steps
 *     through the dots one at a time.
 *
 * All styling lives in the sibling `loader.css` file. Auto-flips
 * for dark theme and respects `prefers-reduced-motion`.
 */
import './loader.css';

const Loader = () => (
  <div
    className="app-loader d-flex justify-content-center align-items-center"
    style={{ height: '90vh' }}
    role="status"
    aria-live="polite"
    aria-label="Loading"
  >
    <div className="app-loader__puck" aria-hidden />
    <div className="app-loader__wave" aria-hidden>
      <span />
      <span />
      <span />
      <span />
      <span />
    </div>
    <div className="app-loader__text">
      <strong>Loading</strong>
    </div>
  </div>
);

export default Loader;
